import React from 'react'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

function QuickListFilters({
  searchText,
  status,
  loading,
  onSearchTextChange,
  onStatusChange,
  onClearFilters,
  onCreate,
}) {
  return (
    <div
      className="quick-list-filters"
      data-testid="container-quick-list-filters">
      <Row className="quick-list-filters-row">
        <Col md={6} lg={4} className="quick-list-search-col">
          <input
            type="text"
            className="form-control"
            data-testid="input-search-quick-list"
            placeholder={t('QUICK_LIST_SETTINGS.LIST.SEARCH_PLACEHOLDER')}
            value={searchText}
            disabled={loading}
            onChange={event => onSearchTextChange(event.target.value)}
          />
        </Col>
        <Col
          md={6}
          lg={3}
          className="quick-list-status-filter"
          data-testid="container-status-filter">
          <label htmlFor="quick-list-status-toggle">
            {status
              ? t('QUICK_LIST_SETTINGS.FORM.ACTIVE')
              : t('QUICK_LIST_SETTINGS.FORM.INACTIVE')}
          </label>
          <div className="toggle">
            <label className="switch">
              <input
                id="quick-list-status-toggle"
                type="checkbox"
                checked={!!status}
                disabled={loading}
                onChange={() => onStatusChange(!status)}
                data-testid="input-status-filter"
              />
              <span className="slider round"></span>
            </label>
          </div>
        </Col>
        <Col md={12} lg={5} className="quick-list-filter-actions">
          <button
            data-testid="btn-clear-filters"
            disabled={loading}
            onClick={onClearFilters}
            className="btn-clean">
            {t('QUICK_LIST_SETTINGS.LIST.CLEAR_FILTERS')}
          </button>
          <button
            data-testid="btn-add-quick-list"
            onClick={onCreate}
            className="btn-add btn-add-quick-list">
            <FontAwesomeIcon icon={faPlus} />
            {t('QUICK_LIST_SETTINGS.LIST.ADD')}
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default QuickListFilters
